import { IDefaultInteface, IPagination, IResponse, IResponseWithPagination } from 'interfaces/common';
import { appService } from 'services';

export const getRoles = async (params?: IPagination) => {
  const response = await appService.get<IResponse<IResponseWithPagination<IDefaultInteface[]>>>('/roles-manage', {
    params: params,
  });
  return response.data;
};
